export interface ReviewedLandingIntentOverride {
  readonly countryCode: string;
  readonly city: string;
  readonly location: string;
}

export interface LandingIntentOverrideTarget {
  full_path?: string | null;
  filter_params?: unknown;
}

/**
 * Explicit, reviewed intent corrections for known landing rows whose stored
 * locale does not describe the market they serve. This is intentionally an
 * exact-path allowlist: never infer a market or city from an arbitrary slug.
 */
export const REVIEWED_LANDING_INTENT_OVERRIDES: Readonly<Record<string, ReviewedLandingIntentOverride>> =
  Object.freeze({
    "/classic-car-rental-london": Object.freeze({
      countryCode: "GB",
      city: "London",
      location: "London",
    }),
  });

function normalizedPath(path: string | null | undefined): string {
  const clean = typeof path === "string" ? path.trim().replace(/^\/+|\/+$/g, "") : "";
  return clean ? `/${clean}` : "/";
}

export function reviewedLandingIntentOverride(
  path: string | null | undefined,
): ReviewedLandingIntentOverride | undefined {
  return REVIEWED_LANDING_INTENT_OVERRIDES[normalizedPath(path)];
}

export function applyReviewedLandingIntentOverride<T extends LandingIntentOverrideTarget>(page: T): T {
  const override = reviewedLandingIntentOverride(page.full_path);
  if (!override) return page;
  const currentFilters = page.filter_params && typeof page.filter_params === "object" &&
    !Array.isArray(page.filter_params)
    ? page.filter_params as Record<string, unknown>
    : {};
  return {
    ...page,
    filter_params: {
      ...currentFilters,
      country_code: override.countryCode,
      city: override.city,
      location: override.location,
    },
  } as T;
}